import { FC, useCallback, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// import { SiteLogo } from "../../assets";
import { AuthContext } from "../../context/authContext";
import { PublicRoutes } from "../../routes/AppRoutes";
import { USER_TYPES } from "src/constants";



const HubSplashScreen: FC = (): JSX.Element => {
  const { isUserAuthorized, userData, isRestoreCalled, restoreSession} = useContext(AuthContext);
  const navigate = useNavigate();
  const checkForAuthentication = useCallback(() => {
    const landingPage = localStorage.getItem("landingPage") || "todos_statistics";
    if (isUserAuthorized && userData) {
      if (USER_TYPES.MANUFACTURER.includes(userData.ref_type)) {
        
        if (userData.ref_type === "fad") {
          if (landingPage === "statistics") {
            navigate(`/${landingPage}`, { replace: true });
          } else {
              if (landingPage === "todos_statistics" || landingPage === "patient_statistics") {
            navigate(`/${landingPage}?id=${userData.id}&role=${userData.ref_type}`, { replace: true });
          }}
        }
        if (userData.ref_type === "area_manager") {
          if (landingPage === "statistics") {
            navigate(`/areas/${userData.id}?id=${userData.id}&type=areas&role=area_manager`);
          } else {
            navigate(`/${landingPage}?id=${userData.id}&role=area_manager`);
          }
        } else if (userData.ref_type === "regional_manager") {
          if (landingPage === "statistics") {
            navigate(`/regions/${userData.id}?id=${userData.id}&type=regions&role=regional_manager`)
          } else {
            navigate(`/${landingPage}?id=${userData.id}&role=regional_manager`)
          }
        } else if (userData.ref_type === "district_manager") {
          if (landingPage === "statistics") {
            navigate(`/district/${userData.id}?id=${userData.id}&type=district&role=district_manager`)
          } else {
            navigate(`/${landingPage}?id=${userData.id}&role=district_manager`)
          }
        } else if (userData.ref_type === "rep") {
          navigate(`/patient_statistics?id=${userData.id}&role=rep&type=territories`)
        } else if (landingPage === "todos_statistics" || landingPage === "statistics" || landingPage === "patient_statistics") {
          navigate(`/${landingPage}`);
        }else{
          navigate(`/${'todos_statistics'}`);
        }
      } else if (USER_TYPES.HCP.includes(userData.ref_type)){
        if(landingPage === "cases" || landingPage === "todos" || landingPage === "patient_dashboards"){
         navigate(`/${landingPage}`);

        }else{
        navigate(`/${`cases`}`);

        }
      }
    } else {
      const indexRoute = PublicRoutes.find((route) => route.isIndex);
      if (indexRoute) navigate(indexRoute.route);
    }
  //}

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthorized]);

  useEffect(() => {
    if (isRestoreCalled) {
      checkForAuthentication();
    } else if (!userData) {
      restoreSession();
    } else {
      const indexRoute = PublicRoutes.find((route) => route.isIndex);
      if (indexRoute) navigate(indexRoute.route);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkForAuthentication, isRestoreCalled]);

  return (
    // <div className="container-fluid row justify-content-center align-items-center pt-4 pb-5" style={{ height: '100vh' }}>
    //   <div className="col-12 text-center">
    //     <img height="110px" className="img-fluid mt-3" src={SiteLogo} alt="Site logo" />

    //     <div className="mt-2">
    //       <div className="spinner-border text-primary" role="status">
    //         <span className="visually-hidden">Loading...</span>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <></>
  );
};

export default HubSplashScreen;
